import './styles.scss';
import cn from 'classnames';
import { EuiIcon } from '@elastic/eui';

export interface DrawerProps {
  isActive: boolean;
  children: React.ReactNode[] | React.ReactNode;
  onClose: () => void;
  onBlur?: () => void;
}

export const Drawer = ({ isActive, children, onClose, onBlur }: DrawerProps): JSX.Element => (
  <div tabIndex={0} onBlur={onBlur} className={cn('drawer', { 'is-active': isActive })}>
    <EuiIcon className="drawer__crossIcon" type="cross" onClick={onClose} />
    {children}
  </div>
);
